import { styled, Dialog, DialogTitle, DialogActions, TextField, Typography, Button } from "@mui/material";

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: '16px',
    maxWidth: '500px',
    width: '100%',
    padding: theme.spacing(3),
  },
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2, 0, 0, 0),
  '& .MuiTypography-root': {
    fontWeight: 700,
    fontSize: '1.25rem',
  },
}));

export const CloseButton = styled('div')(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.grey[500],
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    color: theme.palette.grey[700],
  }
}));

export const DescriptionText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(2), // Reduced from 3
  fontSize: '0.85rem', // Reduced from 0.95rem
}));

export const StyledLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.8rem', // Reduced from 0.875rem
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(0.5), // Reduced from 1
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(0.5),
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: '#fff',
    paddingLeft: theme.spacing(1.5), // Move padding to root for better adornment placement
    '& fieldset': {
      borderColor: theme.palette.grey[300],
    },
    '&:hover fieldset': {
      borderColor: theme.palette.grey[400],
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
    },
  },
  '& input': {
    padding: theme.spacing(1), // Reduced from 1.5
    paddingLeft: theme.spacing(0.5),
  },
  '& .MuiInputAdornment-root': {
    marginRight: 0, // Remove default margin
    '& p': {
      color: theme.palette.text.secondary, // Make $ symbol grey
      fontWeight: 500,
    }
  }
}));

export const HelperText = styled(Typography)(({ theme }) => ({
  fontSize: '0.7rem', // Reduced from 0.75rem
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(2), // Reduced from 3
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(2, 0, 0, 0),
  gap: theme.spacing(2),
  justifyContent: 'space-between',
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(1), // Reduced from 1.5
  borderRadius: '8px',
  textTransform: 'none',
  fontSize: '0.9rem', // Reduced from 1rem
  fontWeight: 600,
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
  },
}));

export const CancelButton = styled(ActionButton)(({ theme }) => ({
  border: '1px solid #568068',
  color: '#568068',
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: '#568068',
    color: '#fff',
  },
}));

export const SubmitButton = styled(ActionButton)(({ theme }) => ({
  backgroundColor: '#568068', // Green
  color: '#fff',
  '&:hover': {
    backgroundColor: '#436d56',
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.grey[400], // Lighter grey than typical default? Or darker? 
    color: '#fff',
  },
}));
